const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_unauthed/auth/reset-password.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
type ResetPasswordSearch = {
  token: string;
} | {
  error: 'INVALID_TOKEN';
};
interface NewPasswordFormValues {
  password: string;
  confirmPassword: string;
}
export const Route = createFileRoute('/_unauthed/auth/reset-password')({
  validateSearch(search: Record<string, unknown>): ResetPasswordSearch {
    if (typeof search.token === 'string' && search.token) {
      return {
        token: search.token
      };
    }
    if (search.error === 'INVALID_TOKEN') {
      return {
        error: 'INVALID_TOKEN'
      };
    }
    throw redirect({
      to: '/auth/reset'
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});